<template>
  <div class="bodywarp">
    <el-card class="box-card boxcard" style="min-height:calc(100% - 30px)">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="公司名称">
          <el-select v-model="formInline.companyname" clearable placeholder="请选择">
            <el-option v-for="item in selectlist" :key="item.ccorpname" :label="item.ccorpname" :value="item.ccorpname"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="物料名称">
          <el-input v-model="formInline.cinvname" placeholder="物料名称"></el-input>
        </el-form-item>
        <el-form-item label="采购订单号">
          <el-input v-model="formInline.cpoid" placeholder="采购订单号"></el-input>
        </el-form-item>
        <el-form-item label="送货日期">
          <el-date-picker v-model="formInline.ddeliverytime" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <Debounce :time='300' :isDebounce="1">
            <el-button type="primary" @click.native="OperationRKorderMainList" size="medium">查询</el-button>
          </Debounce>
          <el-button type="primary" size="medium" @click="exportExcel()">导出</el-button>
        </el-form-item>
      </el-form>

      <div class="text item text-center">

        <el-table :data="tableData1" style="width: 100%" id="out-table" class="tablecenter" show-summary :summary-method="getSummaries" border :cell-style="{ padding: '7px 0' }" :header-cell-style="{ background: '#eef1f6'}">
          <el-table-column prop="cztname" label="公司名称" width="220"></el-table-column>
          <el-table-column prop="cpoid" label="订单号" width="120"></el-table-column>
          <el-table-column prop="drkdate" label="收货日期" width="120">
            <template slot-scope="scope">
              <span v-if="scope.row.drkdate">{{scope.row.drkdate.substring(0,10)}}</span>

            </template>
          </el-table-column>
          <el-table-column prop="csapinvcode" label="SAP物料编号" width="120"></el-table-column>
          <el-table-column prop="cinvname" label="物料名称" min-width="220"></el-table-column>
          <el-table-column prop="cinvstd" label="规格" width="120"></el-table-column>
          <el-table-column prop="cunit" label="单位" width="120"></el-table-column>
          <el-table-column prop="inohg" label="不合格数量" width="120"></el-table-column>
          <el-table-column prop="irbjsqty" label="让步接收数量" width="120"></el-table-column>
        </el-table>
      </div>
      <div class="pull-right" style="padding:20px;">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="[10,20, 50, 100, 1000]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalCount">
        </el-pagination>
      </div>
    </el-card>

  </div>
</template>

<script>
import FileSaver from "file-saver";
import XLSX from "xlsx";
export default {
  data() {
    return {
      formInline: {
        companyname: "",
        cpoid: "",
        cinvname: "",
        ddeliverytime: "",
      },
      tableData1: [],
      // 牧场
      selectlist: {},
      // 分页
      pageSize: 10,
      pageIndex: 1,
      // 页数
      totalCount: 0,
    };
  },
  created() {
    this.OperationRKorderMainList();
    this.GetAccountInfo();
  },
  methods: {
    //定义导出Excel表格事件
    exportExcel() {
      /* 从表生成工作簿对象 */
      var wb = XLSX.utils.table_to_book(document.querySelector("#out-table"), {
        raw: true,
      });
      /* 获取二进制字符串作为输出 */
      var wbout = XLSX.write(wb, {
        bookType: "xlsx",
        bookSST: true,
        type: "array",
      });
      try {
        FileSaver.saveAs(
          //Blob 对象表示一个不可变、原始数据的类文件对象。
          //Blob 表示的不一定是JavaScript原生格式的数据。
          //File 接口基于Blob，继承了 blob 的功能并将其扩展使其支持用户系统上的文件。
          //返回一个新创建的 Blob 对象，其内容由参数中给定的数组串联组成。
          new Blob([wbout], { type: "application/octet-stream" }),
          //设置导出文件名称
          "到货拒收.xlsx"
        );
      } catch (e) {
        if (typeof console !== "undefined") console.log(e, wbout);
      }
      return wbout;
    },
    // 获取table 信息
    OperationRKorderMainList() {
      var starttime;
      var endtime;
      if (this.formInline.ddeliverytime != null) {
        if (this.formInline.ddeliverytime.length != 0) {
          starttime = this.formInline.ddeliverytime[0];
          endtime = this.formInline.ddeliverytime[1];
        } else {
          starttime = "";
          endtime = "";
        }
      } else {
        starttime = "";
        endtime = "";
      }
      this.$axios({
        method: "post",
        url: "CommonModule/Op_SupplierDD/OperationRKorderMainList",
        //data: this.formInline,
        data: {
          startDate: starttime,
          endDate: endtime,
          cpocode: this.formInline.cpoid,
          ccorpname: this.formInline.companyname,
          cinvname: this.formInline.cinvname,
          pageSize: this.pageSize,
          pageIndex: this.pageIndex,
        },
      }).then((res) => {
        console.log(res);
        if (res.data.Data.rows) {
          this.tableData1 = res.data.Data.rows;
          this.totalCount = res.data.Data.totalCount;
        }
      });
    },
    // 获取公司信息
    GetAccountInfo() {
      this.$axios({
        method: "post",
        url: "CommonModule/Op_StoreAndInvoice/GetAccountInfo",
      }).then((res) => {
        console.log(res);
        if (res.data.Success) {
          if (res.data.Message) {
            this.selectlist = res.data.Data;
          }
        } else {
          this.$message.error(res.data.Message);
        }
      });
    },
    // 求和
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (index === 1) {
          sums[index] = "";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));

        if (index == 7 || index == 8) {
          if (!values.every((value) => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] += "";
          } else {
            sums[index] = "N/A";
          }
        }
      });

      return sums;
    },
    // 分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.OperationRKorderMainList();
    },
    // 分页
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.OperationRKorderMainList();
    },
  },
};
</script>


